import { useQuery } from '@tanstack/react-query';
import { qk } from '@cowoo/shared';
import { api } from '../../lib/api';
import { useAdminStore } from '../../lib/store';

export interface NavCounts {
  enquiriesNew: number;
  tasksOpen: number;
  terminalsOffline: number;
  terminalsTotal: number;
}

/**
 * The three badges in the shell (10-web-admin § 3).
 *
 * `GET /admin/nav` is four counts, so it is cheap enough to sit on every
 * screen. It is not polled: `enquiry`, `staff_task` and `terminal_status`
 * invalidate this key as they arrive (04 § 8.6), and a reconnect refetches the
 * whole `admin` prefix. A `viewer` never calls it — the endpoint is staff and
 * would answer `403`.
 */
export function useNav(): NavCounts | null {
  const staff = useAdminStore((state) => state.profile?.role !== 'viewer' && state.profile !== null);

  const nav = useQuery({
    queryKey: qk.admin.area('nav'),
    enabled: staff,
    staleTime: 60_000,
    queryFn: async () => {
      const { data, error } = await api.GET('/admin/nav');
      if (error) throw error;
      return data;
    },
  });

  return nav.data ?? null;
}
